import React from 'react';

import DeployChangesButton from './DeployChangesButton';
import AddIntegrationButton from './AddIntegrationButton';

export default function Actions() {
  return (
    <>
      <AddIntegrationButton />
      <DeployChangesButton />
    </>
  );
}
